import { _values, tsValidateArray, tsValidateNumber, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { PertinentSectionKey } from './types.js';
import { AdvisorRuntimeIDBGroup, Validator_EncounterId } from '@app/advisor-shared';
const allSectionKeys = _values(PertinentSectionKey);
const Validator_PertinentSummaryEntry = {
    _id: tsValidateUniqueId,
    text: tsValidateString(),
    eventTimestamp: tsValidateNumber(false),
    eventDateText: tsValidateString(undefined, false),
    citations: tsValidateArray(tsValidateString()),
};
const Validator_ModifiableProps = {
    ...Validator_EncounterId,
    label: tsValidateString(),
    categoryId: tsValidateUniqueId,
    section: tsValidateValue(allSectionKeys),
    entries: tsValidateArray(Validator_PertinentSummaryEntry),
};
const Validator_GeneratedProps = {};
export const DBDef_RuntimePertinentData = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'runtime-pertinent-summary-sections',
    entityName: 'RuntimePertinentData',
    frontend: {
        group: AdvisorRuntimeIDBGroup,
        name: 'pertinent-data'
    },
    backend: {
        name: 'pertinent-data'
    }
};
//# sourceMappingURL=db-def.js.map